import React from 'react';
// import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
// import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';

import { getChildrenToRender } from '../utils/index';
import { Link } from "react-router-dom";

const colConfig = {
  lg: 8,
  md: 24,
  xs: 24,
  name: 'block',
  className: 'newsdd5-block'
}

function Detail5(props) {
  const { dataSource, newsSource = [], isMobile, ...tagProps } = props;
  const { blockWrapper, titleWrapper } = dataSource;
  const childrenToRender = newsSource.map((item, i) => {
    let tempObj = [
      {
        name: 'image',
        className: 'newsdd5-block-image',
        children: item.thumbnail_img
      },
      {
        name: 'title',
        className: 'newsdd5-block-title',
        children: item.title,
      }
    ]
    return (<Col {...colConfig} key={i.toString()}>
      <Link className="newsdd5-block-group" target="_blank" to={{
        pathname: "/newsDetail/" + item.id,
      }}>
        <div className="block-text">
          {tempObj.map(getChildrenToRender)}
          <div name="content" className="newsdd5-block-content" dangerouslySetInnerHTML={{__html: item.intro}}></div>
        </div>
        <div className="block-addon">
            <span className="newsdd5-block-date"> {item.created_at} </span>
            <span className="newsdd5-block-readmore">Read More</span>
        </div>
      </Link>
    </Col>)
  });
  return (
    <div {...tagProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div {...dataSource.titleWrapper}>
          {titleWrapper.children.map(getChildrenToRender)}
        </div>
        <div>
          <Row
            {...blockWrapper}
          >
            {childrenToRender}
          </Row>
        </div>
      </div>
    </div>
  );
}

export default Detail5;
